/**
 * Placeholder theme until shared design tokens / assets are added.
 * Replace with imports from branding or env-driven values.
 */
export const colors = {
  isDark: false,
  colors: {
    base: {
      primary: '#0061FB',
      primaryDark: '#0B1B1F',
      white: '#FFFFFF',
      black: '#000000',
    },
    neutral: {
      deepGrey: '#292A2E',
      grey: '#6F7678',
      lightGrey: '#E6E6E6',
      grey2: '#0B120E24',
      grey3: '#0B120E23',
      grey4: '#FCFCFC',
      grey5: '#E5E7EB',
      grey6: '#d9d9d9',
      
      seasalt: '#F9F9F9',
      ghostWhite: '#F9FAFB',
      ghostWhite2: '#f1f5f9',
    },
    semantic: {
      success: {
        main: '#34BC52',
        light: '#E8F5E9',
        dark: '#1E7E34',
      },
      error: {
        main: '#F04438',
        light: '#FFEBEE',
        dark: '#B91C1C',
      },
      warning: {
        main: '#F0B638',
        light: '#FFF7E6',
        dark: '#CC5500',
      },
      orange: {
        main: '#FF6B00',
        light: '#FFE66B',
        dark: '#CC5500',
      },
      warning2: {
        main: '#FF6B00',
        light: '#FFF7E6',
      },
      info: {
        main: '#0061FB',
        light: '#E6F2FF',
      },
    },
  },
} as const;
